import './Contacts.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import SalesPhone from '../SalesPhone/SalesPhone.jsx';
import { FaEnvelope, FaPhone } from 'react-icons/fa';
import {
  ALL_ADDRESSES,
  EMAIL,
  EMAIL_HREF,
  PHONE_DISPLAY,
  PHONE_HREF,
  PRIMARY_ADDRESS,
} from '../../constants/contactInfo.js';

const contactRows = [
  {
    role: 'Председатель совета',
    name: 'Харченко Елена Владимировна',
    phone: '8 (846) 3782525',
  },
  {
    role: 'Заместитель председателя совета по пожарной безопасности',
    name: 'Кадьян Александр Александрович',
    phone: '8 (846) 3782525',
  },
  {
    role: 'Начальник Технического отдела - Главный инженер',
    name: 'Буканов Дмитрий Федорович',
    phone: '8 (846) 3782525',
  },
  {
    role: 'Главный инженер проекта',
    name: 'Сухов Андрей Николаевич',
    phone: '8 (846) 3782525',
  },
  {
    role: 'Начальник отдела обслуживания и диспетчеризации',
    name: 'Ольховская Наталья Владимировна',
    phone: '8 (903) 3010160',
  },
  {
    role: 'Начальник отдела социально-ориентированной деятельности',
    name: 'Елисеева Светлана Павловна',
    phone: '8 (846) 3782525',
  },
  {
    role: 'Диспетчерская служба',
    name: 'Кухаренко Матвей Александрович',
    phone: '8 (903) 3010160',
  },
];

const mapUrl = `https://yandex.ru/map-widget/v1/?text=${encodeURIComponent(
  PRIMARY_ADDRESS
)}&z=16`;

function getPhoneHref(phone) {
  const digits = phone.replace(/\D/g, '');
  const normalized = digits.startsWith('8') ? `7${digits.slice(1)}` : digits;

  return `tel:+${normalized}`;
}

function Contacts() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="contacts">
          <div className="contacts__hero">
            <h2 className="contacts__title">Контакты</h2>
          </div>
          <div className="contacts__container">
            <div className="contact__main__container">
              <div className="contact__main__aside">
                <iframe
                  className="contacts__map"
                  src={mapUrl}
                  title="Самарское областное отделение ВДПО на карте"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <div className="contact__main__info">
                <div className="contact__main__title__container">
                  <h2 className="contact__main__title">
                    Самарское областное отделение ВДПО
                  </h2>
                </div>
                <div className="contact__main__contacts__container">
                  <p className="contact__main__contacts">Основные контакты</p>
                  <p className="contact__main__address-label">Адреса</p>
                  <div className="contact__main__addresses">
                    {ALL_ADDRESSES.map((address) => (
                      <p key={address} className="contact__main__address">
                        {address}
                      </p>
                    ))}
                  </div>
                  <div className="contact__main__actions">
                    <div className="contact__main__phones">
                      <a
                        href={PHONE_HREF}
                        className="contact__phone"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaPhone /> {PHONE_DISPLAY}
                      </a>
                      <SalesPhone className="contact__phone" />
                    </div>
                    <a
                      href={EMAIL_HREF}
                      className="contact__email"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaEnvelope /> {EMAIL}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact__info__container">
              <div className="contact__info__container__heading">
                Контактная информация
              </div>
              <div className="contact__info__table">
                {contactRows.map((contact) => (
                  <article className="contact__info__row" key={contact.role}>
                    <div className="contact__info__person">
                      <p className="contact__info__role">{contact.role}</p>
                      <p className="contact__info__name">{contact.name}</p>
                    </div>
                    <div className="contact__info__address">
                      <span>{PRIMARY_ADDRESS}</span>
                    </div>
                    <a
                      href={getPhoneHref(contact.phone)}
                      className="contact__info__phone"
                    >
                      <FaPhone /> {contact.phone}
                    </a>
                  </article>
                ))}
              </div>
            </div>
            <div className="contact__departments__container">
              <div className="contact__departments__container__heading">
                Местные отделения ВДПО
              </div>
              <div className="contact__departments__table">
                <div className="contact__departments__cell contact__departments__cell_role">
                  Самарское городское отделение ВДПО
                </div>
                <div className="contact__departments__cell contact__departments__cell_address">
                  г. Самара, ул. Невская, д. 3, офис 315
                </div>
                <a href={PHONE_HREF} className="contact__departments__phone">
                  <FaPhone /> {PHONE_DISPLAY}
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Contacts;
